import { useTranslation } from 'react-i18next'

import styles from './OrdersTable.module.scss'

const OrdersTable = ({ orders, onSelect }) => {
  const { t } = useTranslation('common')

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>{t('ordersPage.number')}</th>
          <th>{t('ordersPage.date')}</th>
          <th>{t('ordersPage.type')}</th>
          <th>{t('ordersPage.student')}</th>
          <th>{t('ordersPage.status')}</th>
          <th>{t('ordersPage.sign')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {orders.map((o) => (
          <tr key={o.id} onClick={() => onSelect(o)} className={styles.row}>
            <td>{o.number}</td>
            <td>{o.issued_at}</td>
            <td>{o.kind_display}</td>
            <td>{o.student_label}</td>
            <td>
              <span className={`${styles.badge} ${styles[`s_${o.status}`]}`}>
                {o.status_display}
              </span>
            </td>
            <td>{o.signed_at ? `✓ ${o.signed_at?.slice(0, 10)}` : '—'}</td>
            <td>
              {o.pdf_url && (
                <a
                  href={o.pdf_url}
                  onClick={(e) => e.stopPropagation()}
                  className="unv-link"
                  target="_blank"
                  rel="noreferrer"
                >
                  PDF
                </a>
              )}
            </td>
          </tr>
        ))}
        {orders.length === 0 && (
          <tr>
            <td colSpan={7} className={styles.empty}>{t('ordersPage.noOrders')}</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default OrdersTable
